var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };} /* eslint-disable max-statements */
/* eslint-disable react/no-multi-comp */
import React, { useMemo } from 'react';
import { useAtomValue } from 'jotai';
import { templatesAtom, thesauriAtom, relationshipTypesAtom } from "../../../../atoms";
import { Table } from "../../../../Components/UI";
import { propertyIconsSmall } from "../../../../Components/UI/Icons";
import { Translate, t } from "../../../../../I18N";
import { createColumnHelper } from '@tanstack/react-table';


import { translationsKeys } from "../helpers";












const TypeCell =
(currentType) => (cell) => {
  const value = cell.getValue();
  const isMismatch = value !== currentType;
  return (/*#__PURE__*/
    _jsx("span", { className: `flex items-center gap-2 ${isMismatch ? 'text-red-600' : ''}` }, void 0,
    propertyIconsSmall[value],
    t('System', translationsKeys[value] || value, null, false)
    ));

};

const TemplateNameCell =
(currentTemplateId) => (cell) => {
  const value = cell.getValue();
  const { templateId } = cell.row.original;
  return (/*#__PURE__*/
    _jsx("div", { className: "flex items-center gap-2" }, void 0, /*#__PURE__*/
    _jsx(Translate, { context: templateId, truncate: 30 }, void 0,
    value
    ), ' ',
    currentTemplateId === templateId ? `(${t('System', 'this template', null, false)})` : ''
    ));

};

const TemplateNameHeader = () => /*#__PURE__*/_jsx(Translate, {}, void 0, "Template");
const TypeHeader = () => /*#__PURE__*/_jsx(Translate, {}, void 0, "Type");
const ThesauriHeader = () => /*#__PURE__*/_jsx(Translate, {}, void 0, "Thesauri");
const RelationTypeHeader = () => /*#__PURE__*/_jsx(Translate, {}, void 0, "Relation type");
const EntitiesHeader = () => /*#__PURE__*/_jsx(Translate, {}, void 0, "Entities");
const InheritTypeHeader = () => /*#__PURE__*/_jsx(Translate, {}, void 0, "Inherit type");






const ThesauriCellComponent = ({
  value,
  currentContent,
  thesauri
}) => {
  const matches = value === (currentContent || '');
  const thesaurus = thesauri.find((thesaurusItem) => thesaurusItem._id === value);
  const displayName = thesaurus ? thesaurus.name : value || '-';
  return /*#__PURE__*/_jsx("span", { className: matches ? '' : 'text-red-600' }, void 0, displayName);
};

function thesauriCellRenderer(
content,
thesauri)
{
  return (cell) => /*#__PURE__*/
  _jsx(ThesauriCellComponent, { value: cell.getValue(), currentContent: content, thesauri: thesauri });

}

function entitiesCellRenderer(content, templates) {
  return (cell) => {
    const value = cell.getValue();
    const matches = value === content || !content && !value;
    const foundTemplate = templates.find((tmpl) => tmpl._id === value);
    const displayValue = foundTemplate ? /*#__PURE__*/
    _jsx(Translate, { context: foundTemplate._id, truncate: 30 }, void 0,
    foundTemplate.name
    ) : /*#__PURE__*/

    _jsx(Translate, {}, void 0, "Any entity");

    return /*#__PURE__*/_jsx("span", { className: matches ? '' : 'text-red-600' }, void 0, displayValue);
  };
}

function relationTypeCellRenderer(
relationType,
relationshipTypes)
{
  return (cell) => {
    const value = cell.getValue();
    const matches = value === (relationType || '');
    const relationshipType = relationshipTypes.find((rt) => rt._id === value);
    const displayValue = relationshipType ? relationshipType.name : '-';
    return /*#__PURE__*/_jsx("span", { className: matches ? '' : 'text-red-600' }, void 0, displayValue);
  };
}

function inheritTypeCellRenderer(inheritType) {
  return (cell) => {var _cell$getValue;
    const value = (_cell$getValue = cell.getValue()) === null || _cell$getValue === void 0 ? void 0 : _cell$getValue.type;
    const matches = value === inheritType || !inheritType && !value;
    return (/*#__PURE__*/
      _jsx("span", { className: `flex items-center gap-2 ${matches ? '' : 'text-red-600'}` }, void 0,
      propertyIconsSmall[value],
      value ? t('System', translationsKeys[value] || value, null, false) : '-'
      ));

  };
}

export const MatchingPropertiesTable = ({
  label,
  _id,
  type,
  template,
  content,
  relationType,
  inherit








}) => {
  const templates = useAtomValue(templatesAtom);
  const thesauri = useAtomValue(thesauriAtom);
  const relationshipTypes = useAtomValue(relationshipTypesAtom);

  const rows = useMemo(() => {
    const lowerLabel = label === null || label === void 0 ? void 0 : label.trim().toLowerCase();
    let result = templates.flatMap((templ) =>
    [...(templ.properties || [])].
    filter((prop) => {var _prop$label;return ((_prop$label = prop.label) === null || _prop$label === void 0 ? void 0 : _prop$label.trim().toLowerCase()) === lowerLabel;}).
    filter((prop) => prop._id !== _id).
    map((prop) => ({
      templateId: templ._id,
      templateName: templ.name,
      type: prop.type,
      propId: prop._id,
      rowId: `${templ.name}-${prop.name}`,
      content: prop.content,
      relationType: prop.relationType,
      inherit: prop.inherit
    }))
    );

    result = [
    {
      templateId: template._id,
      templateName: template.name,
      type,
      propId: _id,
      rowId: `${template.name}-${label}-current`,
      content,
      relationType,
      inherit
    },
    ...result];


    return result;
  }, [templates, label, _id, type, template, content, relationType, inherit]);

  const columnHelper = createColumnHelper();
  const columns = [
  columnHelper.accessor('templateName', {
    id: 'templateName',
    header: TemplateNameHeader,
    cell: TemplateNameCell(template._id),
    enableSorting: false
  }),
  columnHelper.accessor('type', {
    id: 'type',
    header: TypeHeader,
    cell: TypeCell(type),
    enableSorting: false
  })];


  if (['select', 'multiselect'].includes(type)) {
    columns.push(
      columnHelper.accessor('content', {
        id: 'thesauriOrRelationship',
        header: ThesauriHeader,
        cell: thesauriCellRenderer(content, thesauri),
        enableSorting: false
      })
    );
  }

  if (type === 'relationship') {
    columns.push(
      columnHelper.accessor('relationType', {
        id: 'relationType',
        header: RelationTypeHeader,
        cell: relationTypeCellRenderer(relationType, relationshipTypes),
        enableSorting: false
      }),
      columnHelper.accessor('content', {
        id: 'entities',
        header: EntitiesHeader,
        cell: entitiesCellRenderer(content, templates),
        enableSorting: false
      }),
      columnHelper.accessor('inherit', {
        id: 'inheritType',
        header: InheritTypeHeader,
        cell: inheritTypeCellRenderer(inherit === null || inherit === void 0 ? void 0 : inherit.type),
        enableSorting: false
      })
    );
  }

  return (/*#__PURE__*/
    _jsx("div", { className: "mt-4" }, void 0, /*#__PURE__*/
    _jsx(Table, { columns: columns, data: rows })
    ));

};